function getHelpPath(basePath: string | undefined, helpLink = "") {
	const linkSegment = helpLink && `/${helpLink.replace(/^\//, "")}`;
	return `${basePath || ""}/xoevsuite${linkSegment}`;
}
export default getHelpPath;
